import i18n from "../../../lang/base";
import { FONT } from "../../../value/staticValues";
import { getTimestampToDate, parseKeyValue, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as RedirImg } from '../../../img/ico-prefix-redir.svg';

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import DeploymentAdd from "./DeploymentAdd";
import DeploymentUpdate from "./DeploymentUpdate";
import { DropdownType } from "../../base/CustomDropdown";


export interface PodsData {
    pod_id: string;
    pod_name: string;
    pod_description: string;
    labels:string;
    annotations: string;
    container_count: number;
    container_active_count: number;
    volume_count: number;
    node_name: string;
    restart_policy: string;
    initialized_status_yn: boolean;
    initialized_status_reason: string;
    initialized_status_message: string;
    ready_status_yn: boolean;
    ready_status_reason: string;
    ready_status_message: string;
    containers_ready_status_yn: boolean;
    containers_ready_status_reason: string;
    containers_ready_status_message: string;
    pod_scheduled_status_yn: boolean;
    pod_scheduled_status_reason: string;
    pod_scheduled_status_message: string;
    host_ip_address: string;
    pod_ip_address: string;
    pod_message: string;
    pod_reason: string;
    pod_phase: string;
    create_ts: string;
    update_ts: string;
}


export const initPodsData = {
    pod_id: '',
    pod_name: '',
    pod_description: '',
    labels: '',
    annotations: '',
    container_count: 0,
    container_active_count: 0,
    volume_count: 0,
    node_name: '',
    restart_policy: '',
    initialized_status_yn: false,
    initialized_status_reason: '',
    initialized_status_message: '',
    ready_status_yn: false,
    ready_status_reason: '',
    ready_status_message: '',
    containers_ready_status_yn: false,
    containers_ready_status_reason: '',
    containers_ready_status_message: '',
    pod_scheduled_status_yn: false,
    pod_scheduled_status_reason: '',
    pod_scheduled_status_message: '',
    host_ip_address: '',
    pod_ip_address: '',
    pod_message: '',
    pod_reason: '',
    pod_phase: '',
    create_ts: '',
    update_ts: '',
}


export interface DeploymentPodData {
    deployment_id: string;
    deployment_name: string;
    deployment_description: string;
    deployment_yaml: string;
    labels: string;
    annotations: string;
    selector: string;
    deployment_pod_count: number;
    container_count: number;
    volume_count: number;
    progressing_status_yn: boolean;
    progressing_status_reason: string;
    progressing_status_message: string;
    available_status_yn: boolean;
    available_status_reason: string;
    available_status_message: string;
    restart_policy: string;
    create_ts: string;
    update_ts: string;
    namespace: {
        namespace_id: string;
        namespace_name: string;
    },
    container_cluster: {
        container_cluster_id: string;
        container_cluster_name: string;
    },
    project: {
        project_id: string;
        project_name: string;
    },
    pods: PodsData[];
}


export const initDeploymentPodData = {
    deployment_id: '',
    deployment_name: '',
    deployment_description: '',
    deployment_yaml: '',
    labels: '',
    annotations: '',
    selector: '',
    deployment_pod_count: 0,
    container_count: 0,
    volume_count: 0,
    progressing_status_yn: false,
    progressing_status_reason: '',
    progressing_status_message: '',
    available_status_yn: false,
    available_status_reason: '',
    available_status_message: '',
    restart_policy: '',
    create_ts: '',
    update_ts: '',
    namespace: {
        namespace_id: '',
        namespace_name: '',
    },
    container_cluster: {
        container_cluster_id: '',
        container_cluster_name: '',
    },
    project: {
        project_id: '',
        project_name: '',
    },
    pods: [initPodsData]
}






export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("DEPLOYMENT_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "DEPLOYMENT_CREATE",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "DEPLOYMENT_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "DEPLOYMENT_SYNC",
        }
    },
];


export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("NAME_TEXT"),
        accessor: "deployment_name",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("Progressing"),
        accessor: "progressing_status_yn",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                Up
            </div>
        )
    },
    {
        Header: i18n.t("Available"),
        accessor: "available_status_yn",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                Up
            </div>
        )
    },
    {
        Header: i18n.t("RESTART_POLICY_TEXT"),
        accessor: "restart_policy",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("LABEL_TEXT"),
        accessor: "labels",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{display: "flex", alignItems: "center",
        }}>
             <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                minWidth: 20,
                paddingLeft: 10, paddingRight: 10,
                marginRight: 4,
                borderRadius: 10,
                backgroundColor: "#e6ebf2",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#9ea0a5"}}>
                    {value}
            </div>
        </div>)
    },
    {
        Header: i18n.t("DEPLOYMENT_COUNT_TEXT"),
        accessor: "deployment_pod_count",
        disableSortBy: true,
        style: {
            width: "70px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("CONTAINER_COUNT_TEXT"),
        accessor: "container_count",
        disableSortBy: true,
        style: {
            width: "70px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("CONNECT_VOLUME_COUNT_TEXT"),
        accessor: "volume_count",
        disableSortBy: true,
        style: {
            width: "70px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("CLUSTER_TEXT"),
        accessor: "container_cluster",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.greenText}}>{value?.container_cluster_name ? value?.container_cluster_name : "-"}</div>)
    },
    {
        Header: i18n.t("NAMESPACE_TEXT"),
        accessor: "namespace",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{value?.namespace_name ? value?.namespace_name : "-"}</div>)
    },
    {
        Header: i18n.t("PROJECT_TEXT"),
        accessor: "project",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{value?.project_name ? value?.project_name : "-"}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
];

export const deploymentAddModalContent = {
    title: i18n.t("DEPLOYMENT_CREATE_TEXT"),
    stepCount: 4,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 1,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 2,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 3,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <DeploymentAdd />,
}

export const deploymentUpdateModalContent = {
    title: i18n.t("DEPLOYMENT_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            deleteButtonYn: false,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <DeploymentUpdate />,
}

export const probeExecTypes:DropdownType[] = [
    {
        label: "Command",
        value: "CMD"
    },
    {
        label: "HTTP-GET",
        value: "HTTPGET"
    },
    {
        label: "TCP-SOCKET",
        value: "TCPSOCK"
    },
]


const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    statusImg: {
        marginRight: 3
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    greenText: {
        color: "#3a8344"
    },
    blueText: {
        color: "#0853fb"
    },
    purpleText: {
        color: "#7066f1"
    },
}